import axios from 'axios'
import { Message } from 'element-ui'

// 业务层若已自行提示（Vant $toast），调用本函数可跳过全局红色 Message，避免两条重复提示
let _suppressGlobalErrorUntil = 0;
export function suppressGlobalError(){
    _suppressGlobalErrorUntil = Date.now() + 2000;
}


// 创建axios实例
const service = axios.create({
   // baseURL: process.env.BASE_API, // api的base_url
    baseURL:config.serverIP,
    timeout: 10000000000000000000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
    config.headers['token']      = localStorage.getItem("access_token")
    config.headers['enterprise'] = localStorage.getItem("enterprise")
    return config
}, error => {
    console.log(error) 
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        // 登录失效统一处理：后端 client 的 TokenCheck 返回 451(空token)/452(token无效)/456(账号禁用)，
        // admin 侧为 450；全部视为「需重新登录」。覆盖「记住登录」的两种存储 + client 内嵌登录层。
        if(res.code == 450 || res.code == 451 || res.code == 452 || res.code == 456){
            // 清理登录态（localStorage + sessionStorage，覆盖「记住登录」两种存储）
            localStorage.removeItem("access_token");
            localStorage.removeItem("enterprise");
            sessionStorage.removeItem("access_token");
            sessionStorage.removeItem("enterprise");
            // client 页：token 失效时原地弹出内嵌登录层，延续「登录不跳转」体验（不再硬跳 /login）
            if (window.location.hash.indexOf("#/client") !== -1) {
                window.dispatchEvent(new CustomEvent("auth:expired"));
                return;
            }
            /* 【P118】token 失效也回「本端自己的登录页」：
               销售 → #/client，市场 → #/market，财务/运营 → 各自端。
               这里就地判定（不 import clientAuth，避免 util 之间循环依赖）。 */
            var __h = window.location.hash || '';
            var __home = (__h.indexOf('#/market') === 0) ? '#/market'
                       : (__h.indexOf('#/finance') === 0) ? '#/finance'
                       : (__h.indexOf('#/operation') === 0) ? '#/operation'
                       : '#/client';
            window.location.href = './' + __home;
            return;
        }
        // 统一把后端 payload 返回给调用方，由业务层决定如何提示（避免此处吞掉 res 导致上层拿不到 msg）
        if (res.code == 200) {
            return response.data
        } else {
            // 延后到下一个宏任务：若业务层已自行提示（在其 then 中调用 suppressGlobalError），
            // 则不再弹全局红色提示，避免「两条提示重复」；无人处理时仍作为兜底提示保留。
            const _errMsg = response.data && response.data.msg ? response.data.msg : '操作失败';
            setTimeout(function(){
                if (Date.now() < _suppressGlobalErrorUntil) { return; }
                try {
                    Message && Message({
                        message: _errMsg,
                        type: 'error',
                        duration: 3 * 1000,
                    })
                } catch (e) { console.log('Message toast error', e); }
            }, 0);
            return response.data
        }
    },
    error => {
        try {
            Message && Message({
                message: ""+error,
                type: 'error',
                duration: 3 * 1000,
            })
        } catch (e) { console.log('Message toast error', e); }
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/util/request.js